export default __webpack_public_path__ + "static/media/project6.7607776b.JPG";